/**
 * CARTO Basemaps — key + tile-URL's voor alle Leaflet-kaarten (call-tracking,
 * schoorsteenveger routes/provincies).
 *
 * Sinds aug/sep 2026 vereist CARTO een API-key op de raster-tiles; zonder key
 * verschijnt een "API key required"-watermerk. De key (COOKIES BV) is publiek
 * by design — hij staat in elke tile-request — en gratis tot 5M requests per
 * maand over alle kaarten samen. Zie carto.com/basemaps/apikey. Vector-basemaps
 * vereisen (nog) geen key; raster wordt op termijn uitgefaseerd.
 */

export const CARTO_API_KEY = 'cb1_2oyp_1_5f89d8bae7393413b23b6b83';

// dark_all / light_all sluiten aan op het dashboard-thema; {r} = retina.
export const cartoTileUrl = (isDark) =>
  `https://{s}.basemaps.cartocdn.com/${isDark ? 'dark_all' : 'light_all'}/{z}/{x}/{y}{r}.png?key=${CARTO_API_KEY}`;
